export const STEP_FACULTIES = 'Faculties';
export const STEP_DEPARTMENTS = 'Departments';
export const STEP_PROGRAMMES = 'Programmes';
export const STEP_MODULES = 'Modules';

export const TERTIARY_STEPS = [
  { name: STEP_FACULTIES, label: 'Faculties' },
  { name: STEP_DEPARTMENTS, label: 'Departments' },
  { name: STEP_PROGRAMMES, label: 'Programmes' },
  { name: STEP_MODULES, label: 'Modules' },
] as const;
